export default "__VITE_ASSET__C6EkXev8__"